/*
*###############################################################################
*Module Name                   : VoucherWriteOffContent.js                     #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : T A C Priyashad                               #
*Date                          : Monday, April 27th 2022, 13:14:01             #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState } from 'react'
import { CardText, Col, Row, Alert, Button } from 'reactstrap'
import imageExcelUpload from "../../../assets/images/Upload.png"
import imageExcelDownload from "../../../assets/images/Download.png"
import VoucherWriteOff from "../../../assets/File/VoucherWriteOff.xlsx";
import ReactPaginate from 'react-paginate';
import DPVoucherErrorPopup from 'framework/components/DPVoucherErrorPopup';
import DPTextBox from 'framework/components/DPTextBox';
import DPTextBoxforgrid from 'framework/components/DPTextBoxforgrid';
import { Text } from 'framework/validators/TextValidation';

const VoucherWriteOffContent = ({
    show,
    AlertMsg,
    AlertColor,
    disabledCode,
    ErrorMsg,
    showFileUpload,
    valueUpload,
    onCheckboxChange,
    handleSelectAllChange,
    placeholder,
    searchString,
    setSearchString,
    filteredData,
    currentPage,
    setCurrentPage,
    errorList,
    openErrorList,
    setOpenErrorList,
    handleVoucherCodeChange,
    voucherCode,
    handleAddButton,
    onCommentChange,
    applytoAll
}) => {
    //*** useState to save table data */
    const [postsPerPage] = useState(10)
    //*** End of useStates */

    const indexOfLastPost = currentPage * postsPerPage
    const indexOfFirstPost = indexOfLastPost - postsPerPage
    const currentPosts = filteredData.slice(indexOfFirstPost, indexOfLastPost);

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1);
    };

    const filteredArray = filteredData.filter((item) => item.blCanceled == false)
    const allSelected = filteredArray.every((item) => item.selected == true)

    return (
        <React.Fragment>
            <div>
                <Col sm="12">
                    <CardText className="mb-0">
                        <Row>
                            {show ? (
                                <Alert color={AlertColor} role="alert">
                                    {AlertMsg}
                                    <br />
                                    <small>{ErrorMsg}</small>
                                </Alert>
                            ) : null}
                            <Col sm={12} md={4} className="mb-12-sm">
                                <DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText="Code"
                                    textType="text"
                                    placeholder="Voucher Code"
                                    value={voucherCode}
                                    onChange={handleVoucherCodeChange}
                                />
                            </Col>
                            <Col sm={12} md={6} className="mb-12-sm">
                                <Button
                                    onClick={handleAddButton}
                                    color="success"
                                    className="btn-sm"
                                //disabled={SearchDisable}
                                >
                                    Add
                                </Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} md={12} className="mb-4-sm">
                                <ul className="import-export-button-block" style={{ display: "flex", flexFlow: "row", flexWrap: "wrap", padding: "0px", justifyContent: "end" }}>
                                    <li className="import-export-button" style={{ display: "block" }}>
                                        <input
                                            id="file"
                                            type="file"
                                            onChange={showFileUpload}
                                            value={valueUpload}
                                            disabled={disabledCode}
                                            accept=".xlsx, .xls, .csv"
                                            style={{ display: "none" }}
                                        />
                                        <label htmlFor="file" title="Voucher Write Off Excel Upload" style={{ cursor: "pointer", opacity: disabledCode == true ? "0.5" : "1" }}>
                                            <span >
                                                <img class="manImg" src={imageExcelUpload} style={{ width: "40px", height: "40px" }}></img>
                                            </span>
                                        </label></li>
                                    <li className="import-export-button" style={{ display: "block" }}>
                                        <a href={VoucherWriteOff} download="Voucher Write Off File Upload" data-tip title="Voucher Write Off excel download"
                                            style={{ pointerEvents: disabledCode ? 'none' : '', }} >
                                            <img class="manImg" src={imageExcelDownload} style={{ width: "40px", height: "40px", opacity: disabledCode == true ? "0.5" : "1" }}></img>
                                        </a></li>
                                </ul>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} md={12} className="mb-12-sm">
                                <div className="col-12">
                                    <div className="form-group" style={{ justifyContent: "end", alignItems: 'end', display: 'flex' }}>
                                        <input id="SearchBar" type="text" className="form-control" value={searchString} placeholder={placeholder} aria-label="Username" aria-describedby="basic-addon1" style={{ height: '28px', width: '300px' }}
                                            onChange={e => {
                                                setSearchString(e.target.value);
                                                setCurrentPage(1)
                                            }} />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row className="mt-3">
                            <Col sm={12} md={12} className="mb-12-sm">
                                <table className="table table-bordered  table-sm rounded" style={{ fontSize: "11px", maxHeight: "200px", marginRight: '10px' }} id={"TxnDet"}>
                                    <thead >
                                        <tr style={{ textAlign: "left" }}>
                                            <th>Code</th>
                                            <th>Description</th>
                                            <th style={{ textAlign: "right" }}>Value</th>
                                            <th>Status</th>
                                            <th>Comment</th>
                                            <th>
                                                Select
                                                <input style={{ marginLeft: "5px" }} type="checkbox" name="voucher" checked={allSelected} onChange={handleSelectAllChange} />
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentPosts.map((item, key) => (
                                            <TableRow
                                                key={key}
                                                FormRow={item}
                                                onCheckboxChange={onCheckboxChange}
                                                checked={item.selected}
                                                onCommentChange={onCommentChange}
                                                applytoAll={applytoAll}
                                            />
                                        ))}
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                        <Row sm={12} md={12} className="mb-4-sm">
                            <Col>
                                <ReactPaginate
                                    previousLabel={'Previous'}
                                    nextLabel={'Next'}
                                    breakLabel={'...'}
                                    pageClassName="page-item"
                                    pageLinkClassName="page-link"
                                    previousClassName="page-item"
                                    previousLinkClassName="page-link"
                                    nextClassName="page-item"
                                    nextLinkClassName="page-link"
                                    breakClassName="page-item"
                                    breakLinkClassName="page-link"
                                    pageCount={Math.ceil(filteredData.length / postsPerPage)}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    forcePage={currentPage - 1}
                                    renderOnZeroPageCount={null}
                                    activeClassName={'active'}
                                    activeLinkClassName={'page-link'}
                                    containerClassName={'pagination justify-content-end pagination-sm'}
                                />
                            </Col>
                        </Row>
                    </CardText>
                </Col>
                {openErrorList && (
                    //Error List popup
                    <DPVoucherErrorPopup
                        isOpen={openErrorList}
                        data={errorList}
                        toggle={() => setOpenErrorList(!openErrorList)}
                        mainTitle={"Voucher Error List"}
                    />
                )}

            </div>
        </React.Fragment >
    )
}
export default VoucherWriteOffContent


//Table Row View
const TableRow = ({ FormRow, onCheckboxChange, onCommentChange, applytoAll }) => {
    return (
        <tr key={FormRow.id}>
            <td style={{ width: "100px" }}>
                {FormRow.strCode}
            </td>
            <td style={{ width: "400px" }}>
                {FormRow.strDesc}
            </td>
            <td style={{ width: "100px", textAlign: "right" }}>
                {FormRow.dcValue}
            </td>
            <td style={{ width: "100px" }}>
                {FormRow.blCanceled ? "CANCELED" : FormRow.blStatus ? "ACTIVE" : "INACTIVE"}
            </td>
            <td style={{ width: "400px" }}>
                <DPTextBoxforgrid
                    rowClass="mb-4-sm"
                    labelText=""
                    textType="text"
                    value={FormRow.strComment}
                    onChange={(e) => {

                        let commentValue = Text(e.target, 200, true, true, 'any', true)
                        onCommentChange(FormRow.id, commentValue)

                    }}
                    disabled={FormRow.blCanceled}
                    onKeyDown={(e) => {
                        //enter key press
                        if (e.keyCode == 13 && e.ctrlKey) {
                            applytoAll(FormRow.strComment)
                        }

                    }}
                />
            </td>
            <td style={{ width: "100px" }}>
                <input style={{ marginLeft: "40px" }} type="checkbox" name="voucher" value={FormRow.strCode} checked={FormRow.selected} onChange={() => onCheckboxChange(FormRow.id)} disabled={FormRow.blCanceled} />
            </td>
        </tr>
    )
}